module.exports = __webpack_public_path__ + "static/media/option5.70b93104.png";